module.exports = __webpack_public_path__ + "static/media/isp_logo.c12f6c90.png";